<template>
    <v-container id="cart-totals" fluid class="pa-0">
        <v-row column justify-center align-center>
            <v-col cols="12">
                <v-card v-if="subtotal > 0" id="cart-details">
                    <ValidationObserver
                        ref="observer"
                        v-slot="{ handleSubmit }"
                    >
                        <v-form
                            ref="cartsTotalForm"
                            name="cartsTotalForm"
                            @submit.prevent="handleSubmit(handleNextStep)"
                        >
                            <v-card-text>
                                <SubTotalSection />
                                <CouponSection />
                                <v-simple-table
                                    dense
                                    class="totals-table--bordered"
                                >
                                    <thead>
                                        <tr>
                                            <th class="totals-th--bordered">
                                                <span>
                                                    <TranslatableStringComponent
                                                        :tstring="{
                                                            string:
                                                                'carrierMethod',
                                                        }"
                                                    />
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="totals-td--bordered">
                                                <v-radio-group
                                                    v-model="
                                                        selectedCarrierMethod
                                                    "
                                                    :hide-details="true"
                                                >
                                                    <v-radio
                                                        v-if="
                                                            !isInternationalShipping
                                                        "
                                                        :label="
                                                            localize(
                                                                'defaultCarrier'
                                                            )
                                                        "
                                                        value="default"
                                                        color="primary"
                                                    ></v-radio>
                                                    <v-radio
                                                        :label="
                                                            localize(
                                                                'billToMyCarrier'
                                                            )
                                                        "
                                                        value="billToMyCarrier"
                                                        color="primary"
                                                        :rules="{
                                                            required: isInternationalShipping,
                                                        }"
                                                    ></v-radio>
                                                </v-radio-group>
                                                <!-- NEED TO CONTINUE REFACTOR FOR carrierVendors -->
                                                <div
                                                    v-if="
                                                        selectedCarrierMethod ===
                                                        'billToMyCarrier'
                                                    "
                                                >
                                                    <ValidationProvider
                                                        name="carrierVendorName"
                                                        rules="required"
                                                        class="validationWrapper"
                                                    >
                                                        <div
                                                            slot-scope="{
                                                                errors,
                                                            }"
                                                        >
                                                            <span
                                                                class="validationMessage"
                                                                >{{
                                                                    errors[0]
                                                                }}</span
                                                            >

                                                            <v-radio-group
                                                                id="carrierVendorName"
                                                                v-model="
                                                                    carrierVendorName
                                                                "
                                                                :label="`${localize(
                                                                    'carrierVendor'
                                                                )}:`"
                                                                :row="
                                                                    !isInternationalOrderAboveThreshold
                                                                "
                                                                name="carrierVendorName"
                                                                class="pb-0"
                                                            >
                                                                <v-radio
                                                                    v-for="cv in carrierVendors"
                                                                    :key="cv"
                                                                    :label="cv"
                                                                    :value="cv"
                                                                ></v-radio>
                                                                <v-radio
                                                                    v-if="
                                                                        isInternationalOrderAboveThreshold
                                                                    "
                                                                    label="No Account Available"
                                                                    value="noAccountAvailable"
                                                                >
                                                                </v-radio>
                                                            </v-radio-group>
                                                        </div>
                                                    </ValidationProvider>
                                                    <ValidationProvider
                                                        v-if="
                                                            carrierVendorName !==
                                                            'noAccountAvailable'
                                                        "
                                                        name="shipperNumber"
                                                        :rules="`required|shipperNumber:${getShippingNumberMaxLength},${carrierVendorName}`"
                                                        class="validationWrapper"
                                                    >
                                                        <div
                                                            slot-scope="{
                                                                errors,
                                                            }"
                                                        >
                                                            <span
                                                                class="validationMessage"
                                                                >{{
                                                                    errors[0]
                                                                }}</span
                                                            >
                                                            <v-text-field
                                                                id="shipperNumber"
                                                                v-model="
                                                                    shipperNumber
                                                                "
                                                                name="shipperNumber"
                                                                :label="
                                                                    localize(
                                                                        'shipperNumber'
                                                                    )
                                                                "
                                                                :disabled="
                                                                    !carrierVendorName
                                                                "
                                                                outlined
                                                                dense
                                                                :hide-details="
                                                                    true
                                                                "
                                                                :class="
                                                                    shakeApplied
                                                                "
                                                            ></v-text-field>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <v-simple-table
                                    v-if="isInternationalShipping"
                                    dense
                                    class="totals-table--bordered"
                                >
                                    <thead>
                                        <tr>
                                            <th class="totals-th--bordered">
                                                <span>
                                                    <TranslatableStringComponent
                                                        :tstring="{
                                                            string:
                                                                'internationalShippingMethod',
                                                        }"
                                                    />
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="totals-td--bordered">
                                                <ValidationProvider
                                                    name="internationalShippingMethod"
                                                    :rules="{
                                                        required:
                                                            carrierVendorName ===
                                                                'FedEx' ||
                                                            carrierVendorName ===
                                                                'UPS' ||
                                                            carrierVendorName ===
                                                                'DHL',
                                                    }"
                                                    class="validationWrapper"
                                                >
                                                    <div
                                                        slot-scope="{ errors }"
                                                    >
                                                        <span
                                                            class="validationMessage"
                                                            >{{
                                                                errors[0]
                                                            }}</span
                                                        >

                                                        <v-radio-group
                                                            id="internationalShippingMethod"
                                                            v-model="
                                                                internationalShippingMethod
                                                            "
                                                            name="internationalShippingMethod"
                                                            class="pb-0"
                                                        >
                                                            <v-radio
                                                                v-for="item in internationalShippingOptions"
                                                                :key="item"
                                                                :label="item"
                                                                :value="item"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </div>
                                                </ValidationProvider>
                                                <p style="font-size: 12px">
                                                    <fa
                                                        :icon="[
                                                            'fal',
                                                            'info-circle',
                                                        ]"
                                                        v-bind="attrs"
                                                        class="fa-lg mr-2"
                                                        style="color: #0063a6"
                                                    />
                                                    <TranslatableStringComponent
                                                        :tstring="{
                                                            string:
                                                                'shippingTBDNote',
                                                        }"
                                                    />
                                                </p>
                                                <p
                                                    v-if="
                                                        isInternationalShipping
                                                    "
                                                    style="font-size: 12px"
                                                >
                                                    <fa
                                                        :icon="[
                                                            'fal',
                                                            'info-circle',
                                                        ]"
                                                        v-bind="attrs"
                                                        class="fa-lg mr-2"
                                                        style="color: #0063a6"
                                                    />
                                                    <TranslatableStringComponent
                                                        :tstring="{
                                                            string:
                                                                'internationalDutiesMsg',
                                                        }"
                                                    />
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                <ShippingMethodSection />
                                <HandlingFeeSection />
                                <OversizedPackageShippingSection />
                                <TariffSection />
                                <SalesTaxSection />
                                <GrandTotalSection />
                            </v-card-text>
                            <v-card-actions v-if="$vuetify.breakpoint.mdAndUp">
                                <div v-if="isCart">
                                    <v-btn dense color="primary" type="submit">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'proceedToCheckout',
                                            }"
                                        />
                                    </v-btn>
                                </div>
                                <div v-if="isCheckout && isCustomerCreated">
                                    <v-btn
                                        dense
                                        color="primary"
                                        type="submit"
                                        @click="scrollIntoView()"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'proceedToPayment',
                                            }"
                                        />
                                    </v-btn>
                                </div>
                                <div v-if="isCheckout && !isCustomerCreated">
                                    <v-btn
                                        dense
                                        color="primary"
                                        type="submit"
                                        @click="scrollIntoView()"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'proceedToCustomerDetails',
                                            }"
                                        />
                                    </v-btn>
                                </div>
                            </v-card-actions>
                            <v-card
                                v-else
                                :elevation="14"
                                style="border-radius: 0"
                                :fixed="true"
                                class="checkout-bottom-navigation py-2 px-5 d-flex justify-space-between"
                            >
                                <div class="d-flex flex-column">
                                    <strong
                                        class="text-center"
                                        style="
                                            font-size: 18px;
                                            line-height: initial;
                                        "
                                        >{{ dollars(total) }}</strong
                                    >
                                    <v-btn
                                        height="16px"
                                        small
                                        text
                                        dense
                                        color="primary"
                                        @click="$vuetify.goTo('#cart-details')"
                                        ><TranslatableStringComponent
                                            :tstring="{
                                                string: 'viewDetails',
                                            }"
                                    /></v-btn>
                                </div>
                                <div class="d-flex flex-row align-center">
                                    <v-btn
                                        v-if="isCart"
                                        dense
                                        :x-small="$vuetify.breakpoint.smAndDown"
                                        color="primary"
                                        type="submit"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'proceedToCheckout',
                                            }"
                                        />
                                    </v-btn>
                                    <v-btn
                                        v-if="isCheckout && isCustomerCreated"
                                        dense
                                        :x-small="$vuetify.breakpoint.smAndDown"
                                        color="primary"
                                        type="submit"
                                        @click="scrollIntoView()"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'proceedToPayment',
                                            }"
                                        />
                                    </v-btn>
                                    <v-btn
                                        v-if="isCheckout && !isCustomerCreated"
                                        dense
                                        :x-small="$vuetify.breakpoint.smAndDown"
                                        color="primary"
                                        type="submit"
                                        @click="scrollIntoView()"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string:
                                                    'proceedToCustomerDetails',
                                            }"
                                        />
                                    </v-btn>
                                </div>
                            </v-card>
                        </v-form>
                    </ValidationObserver>
                </v-card>
                <v-card v-else>
                    <v-card-text>
                        <span
                            ><TranslatableStringComponent
                                :tstring="{ string: 'yourCartIsEmpty' }"
                        /></span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <ConnectCustomerDialog
            :showModal="showModal"
            :stepperValue="stepperValue"
            @handleProceedCheckout="
                () => {
                    handleDialog()
                    proceedWithCheckout()
                }
            "
            @handleDialog="handleDialog()"
            @handlePostCustomerConnect="handlePostCustomerConnect()"
            @changeStepperValue="stepperValue = '2'"
        />
        <UnavailableProductWarningModal
            :showModal="showUnavailableProductsModal"
            @handleProceedCheckout="
                () => {
                    handleDialog()
                    proceedWithCheckout()
                }
            "
            @handleDialog="handleDialog()"
        />
    </v-container>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import handleSnackbar from '~/mixins/handleSnackbar'
import scrollIntoView from '~/mixins/scrollIntoView'
import UnavailableProductWarningModal from '~/components/UnavailableProductWarningModal.vue'
import ConnectCustomerDialog from '~/components/ConnectCustomerDialog.vue'
import SubTotalSection from '~/components/cartTotalSections/SubTotalSection.vue'
import CouponSection from '~/components/cartTotalSections/CouponSection.vue'
import ShippingMethodSection from '~/components/cartTotalSections/ShippingMethodSection.vue'
import HandlingFeeSection from '~/components/cartTotalSections/HandlingFeeSection.vue'
import OversizedPackageShippingSection from '~/components/cartTotalSections/OversizedPackageShippingSection.vue'
import TariffSection from '~/components/cartTotalSections/TariffSection.vue'
import SalesTaxSection from '~/components/cartTotalSections/SalesTaxSection.vue'
import GrandTotalSection from '~/components/cartTotalSections/GrandTotalSection.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

export default {
    name: 'CartTotals',
    components: {
        ValidationProvider,
        ValidationObserver,
        ConnectCustomerDialog,
        SubTotalSection,
        CouponSection,
        ShippingMethodSection,
        HandlingFeeSection,
        OversizedPackageShippingSection,
        TariffSection,
        SalesTaxSection,
        GrandTotalSection,
        TranslatableStringComponent,
        UnavailableProductWarningModal,
    },
    mixins: [handleSnackbar, scrollIntoView],

    props: {
        isCart: {
            type: Boolean,
            default: false,
        },
        isCheckout: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            attrs: null,
            showModal: false,
            stepperValue: '1',
            showUnavailableProductsModal: false,
        }
    },
    computed: {
        ...mapGetters({
            subtotal: 'cart/fetchCartSubtotal',
            tariffs: 'cart/fetchCartTariffTotal',
            fetchShippingCharges: 'cart/fetchShippingCharges',
            taxes: 'cart/fetchCartTaxTotal',
            handlingFee: 'cart/fetchHandlingFee',
            fetchHandlingFeePerItemTotal: 'cart/fetchHandlingFeePerItemTotal',
            total: 'cart/fetchCartTotal',
            carrierVendors: 'cart/fetchCarrierVendors',
            shippingOptions: 'cart/fetchShippingOptions',
            salesTaxPercentage: 'cart/salesTaxPercentage',
            fetchShippingOptions: 'cart/fetchShippingOptions',
            isFreeGroundShipping: 'cart/isFreeGroundShipping',
            discountValue: 'coupon/discountValue',
            isCustomerCreated: 'auth/isCustomerCreated',
            isInternationalShipping: 'checkout/isInternationalShipping',
            isInternationalOrderAboveThreshold:
                'cart/isInternationalOrderAboveThreshold',
            internationalShippingOptions:
                'cart/fetchInternationalShippingOptions',
            isDistributor: 'auth/isDistributor',
            freeGroundShippingThreshold: 'auth/freeGroundShippingThreshold',
            shippingExemptionFound: 'cart/shippingExemptionFound',
            sameDayShippingExemptionFound: 'cart/sameDayShippingExemptionFound',
            isShippingTBD: 'cart/isShippingTBD',
            isCustomerConnected: 'auth/isCustomerConnected',
            isLoggedIn: 'auth/isLoggedIn',
            shippingChargedProducts: 'cart/shippingChargedProducts',
        }),
        ...mapState('cart', ['carrierMethods', 'carrierMethodSelected']),
        ...mapState('checkout', [
            'billingFormArray',
            'selectedBillingAddressID',
            'selectedShippingAddressID',
        ]),
        ...mapState('coupon', ['couponObj']),
        correctShippingPrices: {
            get() {
                return this.$store.state.cart.correctShippingPrices
            },
            set(v) {
                if (!v) {
                    this.$store.commit('cart/updateShippingOptions', 'ground')
                }
            },
        },
        selectedCarrierMethod: {
            get() {
                return this.$store.state.cart.selectedCarrierMethod
            },
            set(v) {
                if (this.isInternationalShipping) {
                    this.$store.dispatch(
                        'cart/updateCarrier',
                        'billToMyCarrier'
                    )
                } else {
                    this.$store.dispatch('cart/updateCarrier', v)
                }
            },
        },
        selectedShippingMethod: {
            get() {
                return this.$store.state.cart.selectedShippingMethod
            },
            set(v) {
                this.$store.dispatch('cart/updateShipping', v)
            },
        },
        internationalShippingMethod: {
            get() {
                return this.$store.state.cart.internationalShippingMethod
            },
            set(v) {
                if (this.carrierVendorName === 'DHL') {
                    this.$store.dispatch(
                        'cart/updateInternationalShippingMethod',
                        'DHL Collect'
                    )
                } else {
                    this.$store.dispatch(
                        'cart/updateInternationalShippingMethod',
                        v
                    )
                }
            },
        },
        shipperNumber: {
            get() {
                return this.$store.state.cart.shipperNumber
            },
            set(v) {
                this.$store.commit('cart/updateShipperNumber', v)
            },
        },
        carrierVendorName: {
            get() {
                return this.$store.state.cart.carrierVendorName
            },
            set(v) {
                this.$store.commit('cart/updateShipperNumber', '')
                this.$store.commit('cart/updateCarrierVendorName', v)
            },
        },
        getShippingNumberMaxLength() {
            if (this.carrierVendorName === 'FedEx') {
                return '9'
            } else if (this.carrierVendorName === 'UPS') {
                return '6'
            } else {
                return ''
            }
        },
        fetchGroundShippingCost() {
            if (this.discountValue && this.couponObj.freeShipping) {
                return `(FREE)` // `(${this.dollars(0, 0)}) `
            } else if (this.isDistributor) {
                if (
                    this.freeGroundShippingThreshold &&
                    this.freeGroundShippingThreshold !== '0' &&
                    this.subtotal > parseInt(this.freeGroundShippingThreshold)
                ) {
                    return `(FREE)` // `(${this.dollars(0, 0)}) `
                } else {
                    return this.fetchShippingOptions.groundDist === 0
                        ? `(FREE)`
                        : `(${this.dollars(
                              this.fetchShippingOptions.groundDist,
                              0
                          )})`
                }
            } else {
                return this.fetchShippingOptions.ground === 0
                    ? `(FREE)`
                    : `(${this.dollars(this.fetchShippingOptions.ground, 0)})`
            }
        },
        isFreeGroundShippingApplied() {
            if (this.discountValue && this.couponObj.freeShipping) {
                return true
            } else {
                return false
            }
        },
        shakeApplied() {
            if (!this.shipperNumber) {
                return 'input-shake'
            } else {
                return ''
            }
        },
        handlingFeeTotal() {
            return this.handlingFee + this.fetchHandlingFeePerItemTotal
        },
    },
    methods: {
        handleRemoveCoupon() {
            this.$store.dispatch('coupon/removeCoupon')
        },
        handleNextStep() {
            if (this.isCart) {
                if (
                this.getUnavailableProductListInElastic &&
                this.getUnavailableProductListInElastic.length > 0
            )
                this.showUnavailableProductsModal = true
                else if (!this.isCustomerConnected) this.showModal = true
                else this.proceedWithCheckout()
            } else if (this.billingFormArray.length === 0) {
                this.hitSnackbar(
                    { string: 'pleaseAddAddressToProceedToPayment' },
                    ''
                )
            } else if (
                !this.selectedBillingAddressID &&
                !this.selectedShippingAddressID
            ) {
                this.hitSnackbar({ string: 'pleaseAddBillingShippingInfo' }, '')
            } else if (!this.selectedBillingAddressID) {
                this.hitSnackbar({ string: 'pleaseSelectBillingAddress' }, '')
            } else if (!this.selectedShippingAddressID) {
                this.hitSnackbar({ string: 'pleaseSelectShippingAddress' }, '')
            } else {
                const page = this.isCustomerCreated
                    ? 'payment'
                    : 'customer-details'
                this.routerPush({ type: 'page', slugName: page })
            }
        },
        proceedWithCheckout() {
            this.routerPush({ type: 'page', slugName: 'checkout' })
        },
        handleDialog() {
            this.showModal = false
            this.stepperValue = '1'
            this.showUnavailableProductsModal = false
        },
        handlePostCustomerConnect() {
            this.handleDialog()
            this.proceedWithCheckout()
        },
    },
    mounted() {
        if (this.isInternationalShipping) {
            this.selectedCarrierMethod = 'billToMyCarrier'
        }
    },
}
</script>
<style lang="scss" scoped>
.checkout-bottom-navigation {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
}
</style>
